import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  let regexEI = "^\\d{2}\\-\\d{7}\\w{2}$"
  let regex34 = "^\\d{3}\\-\\d{2}\\-\\d{4}$"
  let regexANI = "^\\d{6}\\-\\d{5}$"
  let regexCIN = "^\\-\\w{11}$"
  let regexDUN = "^\\d{9}$"
  let regexDNS = "^\\d{13}$"
  let regexAEF = "^[a-zA-Z0-9]+$"

  const regexAlphaNumericSpecChar = "^[a-zA-Z0-9!\"\',-./:;?=()_@./#&+\-,\\s]*$"

  return Yup.object({
    partyType: Yup.string().required(requiredMessage).nullable(),
    docType: Yup.string().when('partyType', {
      is: (partyType) => (partyType === 'IM' || partyType === 'CN'),
      then: Yup.string().required(requiredMessage).nullable()
    }).nullable(),
    docNumber: Yup.string().when('docType', {
      is: (docType) => (docType === 'EI'),
      then: Yup.string().nullable().matches(/^[a-zA-Z0-9-\-]+$/, "Please enter alphanumeric values and allowed character is -").required(requiredMessage).nullable().matches(regexEI, "Incorrect Document Number format: NN-NNNNNNNXX")
    })
      .when('docType', {
        is: (docType) => (docType === '34'),
        then: Yup.string().nullable().matches(/^[a-zA-Z0-9-\-]+$/, "Please enter alphanumeric values and allowed character is -").required(requiredMessage).nullable().matches(regex34, "Incorrect Document Number format: NNN-NN-NNNN")
      })
      .when('docType', {
        is: (docType) => (docType === 'ANI'),
        then: Yup.string().nullable().matches(/^[a-zA-Z0-9-\-]+$/, "Please enter alphanumeric values and allowed character is -").required(requiredMessage).nullable().matches(regexANI, "Incorrect Document Number format: YYDDPP-NNNNN")
      })
      .when('docType', {
        is: (docType) => (docType === 'CIN'),
        then: Yup.string().nullable().matches(/^[a-zA-Z0-9-\-]+$/, "Please enter alphanumeric values and allowed character is -").required(requiredMessage).nullable().matches(regexCIN, "Incorrect Document Number format: -CCCCCCCCCCC")
      })
      .when('docType', {
        is: (docType) => (docType === 'DUN'),
        then: Yup.string().nullable().matches(/^[a-zA-Z0-9\-]+$/, "Please enter only alphanumeric(without spaces)").required(requiredMessage).nullable().matches(regexDUN, "Incorrect Document Number format: NNNNNNNNN")
      })
      .when('docType', {
        is: (docType) => (docType === 'DNS'),
        then: Yup.string().nullable().matches(/^[a-zA-Z0-9\-]+$/, "Please enter only alphanumeric(without spaces)").required(requiredMessage).nullable().matches(regexDNS, "Incorrect Document Number format: NNNNNNNNNNNNN")
      })
      .when('docType', {
        is: (docType) => (docType === 'AEF'),
        then: Yup.string().nullable().matches(regexAEF, "Incorrect Importer Document Number format: XXXXXXXXXXXXXXX")
      })
      .when('partyType', {
        is: (partyType) => (partyType === 'IM' || partyType === 'CN'),
        then: Yup.string().required(requiredMessage).nullable()
      }).nullable(),
    partyName: Yup.string().when('docType', {
      is: (docType) => (!docType),
      then: Yup.string().matches(regexAlphaNumericSpecChar, "Please enter alphanumeric values and allowed characters are ,-./:;?=()_@./#&+").required(requiredMessage).nullable()
        .test('no-nbsp', 'Party Name must not contain non-breaking spaces (&nbsp;)', (value) => !value || !value.includes('\u00a0'))
    }).nullable()
      .test('no-nbsp', 'Party Name must not contain non-breaking spaces (&nbsp;)', (value) => !value || !value.includes('\u00a0')),
    secondaryInfoType: Yup.string().nullable(),
    secondaryInfo: Yup.string().matches(regexAlphaNumericSpecChar, "Please enter alphanumeric values and allowed characters are ,-./:;?=()_@./#&+").nullable(),
    address: Yup.string().when('docType', {
      is: (docType) => (!docType),
      then: Yup.string().matches(regexAlphaNumericSpecChar, "Please enter alphanumeric values and allowed characters are ,-./:;?=()_@./#&+").required(requiredMessage).nullable()
    }).nullable(),
    city: Yup.string().when('docType', {
      is: (docType) => (!docType),
      then: Yup.string().matches(regexAlphaNumericSpecChar, "Please enter alphanumeric values and allowed characters are ,-./:;?=()_@./#&+").required(requiredMessage).nullable()
    }).nullable(),
    country: Yup.string().when('docType', {
      is: (docType) => (!docType),
      then: Yup.string().required(requiredMessage).nullable()
    }).nullable(),
    province: Yup.string().nullable(),
    postalCode: Yup.string().matches(regexAlphaNumericSpecChar, "Please enter alphanumeric values and allowed characters are ,-./:;?=()_@./#&+").nullable(),
    htsList: Yup.array().of(Yup.object({
      manufacturerPartyId: Yup.string().nullable(),
      htsNo: Yup.string().matches(/^[0-9\-]+$/, "Please enter only numeric(without spaces)").required(requiredMessage).nullable(),
      countryOrigin: Yup.string().required(requiredMessage).nullable(),
    }))
  })
}

export default makeValidationSchema
